// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"7f39a6d9","171":"824e019a","453":"af897257","507":"bd2f57b8","594":"b1a12a3b","628":"29141258","801":"13c36a32","845":"f7df4311","870":"5e0908c8","952":"fbaee357"}[chunkId] + ".chunk.js";
};